export const cars =[
    {
        image: "/images/Toyota_Yaris/1.jpg",
        // title: "Toyota Yarus"
    },
    {
        image: "/images/Toyota_Yaris/2.jpg",
        // title: "Toyota Yarus"
    },
    {
        image: "/images/Toyota_Yaris/3.jpg",
        // title: "Toyota Yarus"
    },
    {
        image: "/images/Toyota_Yaris/4.jpg",
        // title: "Toyota Yarus"
    },
    {
        image: "/images/Toyota_Yaris/5.jpg",
        // title: "Toyota Yarus"
    }
];